// Components
import { Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"

// Screens
import History from "./history"
import Careers from "./careers"
import Anticipations from "./anticipations";

export default function Cycle({ data:consultant }){
    return(
    <Tabs isLazy size="sm" variant="solid-rounded" colorScheme="orange">
        <TabList>
            <Tab>Histórico de Ciclos</Tab>
            <Tab>Histórico de Pins</Tab>
            <Tab>Histórico de Antecipações</Tab>
        </TabList>
        <TabPanels>
            <TabPanel><History data={consultant} /></TabPanel>
            <TabPanel><Careers data={consultant} /></TabPanel>
            <TabPanel><Anticipations data={consultant} /></TabPanel>
        </TabPanels>
    </Tabs>
    )
}